import { DialogService } from 'primeng/dynamicdialog';
import { ExportDialogComponent } from '../export-dialog/export-dialog.component';
import { ExportApiService, CreateExportJobRequest } from '../services/export/export-api.service';
import { ToasterService } from '@ui-nuvertos/auth';
import { openInNewTab } from './url.utils';

export class ExportHelper {

  static openExportDialog(
    config: {
      module: string;
      columns: any[];
      filters: Record<string, any>;
      defaultFormat: 'excel' | 'csv';
      hasActiveFilters?: boolean;
      title?: string;
    },
    dialogService: DialogService,
    exportApiService: ExportApiService,
    toasterService: ToasterService
  ) {

    const dialogRef = dialogService.open(ExportDialogComponent, {
      header: config.title || `Export ${config.module}`,
      width: '500px',
      data: {
        module: config.module,
        columns: config.columns,
        filters: config.filters,
        hasActiveFilters: config.hasActiveFilters ?? false,
        defaultFormat: config.defaultFormat
      }
    });

    if (dialogRef) {
      dialogRef.onClose.subscribe((request: CreateExportJobRequest) => {
        if (request) {
          ExportHelper.startExport(request, exportApiService, toasterService);
        }
      });
    }
  }

  static startExport(
    request: CreateExportJobRequest,
    exportApiService: ExportApiService,
    toasterService: ToasterService
  ) {
    exportApiService.createExportJob(request).subscribe({
      next: () => {
        toasterService.success(
          'Export Started',
          'Your export is processing. Click here to view progress →',
          5000
        );
        setTimeout(() => openInNewTab('/exports'), 1500);
      },
      error: (err: any) => {
        const message = err?.error?.message || 'Failed to start export';
        toasterService.error('Export Failed', message);
      }
    });
  }

  static hasActiveFilters(filters: Record<string, any>): boolean {
    return Object.values(filters).some(
      value =>
        value !== undefined &&
        value !== null &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0)
    );
  }
}